export default __webpack_public_path__ + "static/media/imss.1d4323c6.jpg";